/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsers.defs'
export { main as default } from './getSuggestedUsers.defs'
